import classNames from 'classnames';
import React from 'react';
import './headline.scss';

export interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  size?: number;
}

const Headline = ({
  headingLevel = 'p',
  size = 1,
  children,
  className,
}: Props) => {
  const Heading = ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) =>
    React.createElement(headingLevel, props, children);

  return (
    <Heading className={classNames('headline', `headline--${size}`, className)}>
      {children}
    </Heading>
  );
};

export default Headline;
